import './password-strength-meter.scss';

import { ReactComponent as CheckIcon } from '../../assets/icons/check.svg';
import { calculatePasswordStrength } from '../../utils/password-strength';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const PasswordStrengthMeter = ({ password }) => {
  if (!password) {
    return null;
  }

  const { level, label } = calculatePasswordStrength(password);

  const criteria = [
    { met: /[^\w]/.test(password), label: 'At least one special character' },
    { met: /[A-Z]/.test(password), label: 'Upper case character' },
    { met: /[a-z]/.test(password), label: 'Lower case character' },
    { met: /[0-9]/.test(password), label: 'At least one number' }
  ];

  return (
    <div className="password-strength-meter">
      <div className="password-strength-meter__header">
        <span className="password-strength-meter__title">Password strength:</span>
        <span
          className={classNames('password-strength-meter__label', {
            [`password-strength-meter__label--level-${level}`]: true
          })}>
          {label}
        </span>
      </div>
      <div className="password-strength-meter__bars">
        {[1, 2, 3, 4].map((barLevel) => (
          <div
            key={barLevel}
            className={classNames('password-strength-meter__bar', {
              'password-strength-meter__bar--filled': barLevel <= level,
              [`password-strength-meter__bar--level-${level}`]: barLevel <= level
            })}
          />
        ))}
      </div>
      <div className="password-strength-meter__criteria">
        {criteria.map((criterion, index) => (
          <div
            key={index}
            className={classNames('password-strength-meter__criterion', {
              'password-strength-meter__criterion--met': criterion.met
            })}>
            <CheckIcon />
            <span>{criterion.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

PasswordStrengthMeter.propTypes = {
  password: PropTypes.string
};

export { PasswordStrengthMeter };
